/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormSectionResponse } from './FormSectionResponse';
import {
    FormSectionResponseFromJSON,
    FormSectionResponseFromJSONTyped,
    FormSectionResponseToJSON,
} from './FormSectionResponse';

/**
 * 
 * @export
 * @interface InspectionFormResponse
 */
export interface InspectionFormResponse {
    /**
     * 
     * @type {string}
     * @memberof InspectionFormResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionFormResponse
     */
    scheduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionFormResponse
     */
    snapshotId?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionFormResponse
     */
    templateId?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionFormResponse
     */
    versionId?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionFormResponse
     */
    machineId?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionFormResponse
     */
    status?: InspectionFormResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof InspectionFormResponse
     */
    assignedOperatorId?: string;
    /**
     * 
     * @type {Date}
     * @memberof InspectionFormResponse
     */
    generatedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InspectionFormResponse
     */
    dueAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InspectionFormResponse
     */
    completedAt?: Date;
    /**
     * 
     * @type {Array<FormSectionResponse>}
     * @memberof InspectionFormResponse
     */
    sections?: Array<FormSectionResponse>;
    /**
     * 
     * @type {Date}
     * @memberof InspectionFormResponse
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InspectionFormResponse
     */
    updatedAt?: Date;
}


/**
 * @export
 */
export const InspectionFormResponseStatusEnum = {
    Pending: 'PENDING',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Overdue: 'OVERDUE',
    Cancelled: 'CANCELLED'
} as const;
export type InspectionFormResponseStatusEnum = typeof InspectionFormResponseStatusEnum[keyof typeof InspectionFormResponseStatusEnum];


/**
 * Check if a given object implements the InspectionFormResponse interface.
 */
export function instanceOfInspectionFormResponse(value: object): value is InspectionFormResponse {
    return true;
}

export function InspectionFormResponseFromJSON(json: any): InspectionFormResponse {
    return InspectionFormResponseFromJSONTyped(json, false);
}

export function InspectionFormResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionFormResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'scheduleId': json['scheduleId'] == null ? undefined : json['scheduleId'],
        'snapshotId': json['snapshotId'] == null ? undefined : json['snapshotId'],
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'versionId': json['versionId'] == null ? undefined : json['versionId'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'status': json['status'] == null ? undefined : json['status'],
        'assignedOperatorId': json['assignedOperatorId'] == null ? undefined : json['assignedOperatorId'],
        'generatedAt': json['generatedAt'] == null ? undefined : (new Date(json['generatedAt'])),
        'dueAt': json['dueAt'] == null ? undefined : (new Date(json['dueAt'])),
        'completedAt': json['completedAt'] == null ? undefined : (new Date(json['completedAt'])),
        'sections': json['sections'] == null ? undefined : ((json['sections'] as Array<any>).map(FormSectionResponseFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function InspectionFormResponseToJSON(value?: InspectionFormResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'scheduleId': value['scheduleId'],
        'snapshotId': value['snapshotId'],
        'templateId': value['templateId'],
        'versionId': value['versionId'],
        'machineId': value['machineId'],
        'status': value['status'],
        'assignedOperatorId': value['assignedOperatorId'],
        'generatedAt': value['generatedAt'] == null ? undefined : ((value['generatedAt']).toISOString()),
        'dueAt': value['dueAt'] == null ? undefined : ((value['dueAt']).toISOString()),
        'completedAt': value['completedAt'] == null ? undefined : ((value['completedAt']).toISOString()),
        'sections': value['sections'] == null ? undefined : ((value['sections'] as Array<any>).map(FormSectionResponseToJSON)),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

